import React, { useState } from 'react';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import CircularProgress from '@mui/material/CircularProgress';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import { AxiosResponse } from 'axios';

import ExportDownloadConfirmDialog from './Modals/ExportDownloadConfirmDialog';
import { downloadBlobResponse } from '../DownloadReport/downloadUtils';

export default function ExportDownloadMenuItem({ label, fallbackFilename, fetchExport, onComplete }: {
  label: string;
  fallbackFilename: string;
  fetchExport: () => Promise<AxiosResponse<Blob>>;
  onComplete: () => void;
}) {
  const [loading, setLoading] = useState(false);
  const [errorOpen, setErrorOpen] = useState(false);
  const [confirmOpen, setConfirmOpen] = useState(false);

  const handleDownload = async () => {
    setConfirmOpen(false);
    try {
      setLoading(true);
      const response = await fetchExport();
      downloadBlobResponse(response, fallbackFilename);
      setLoading(false);
      onComplete();
    } catch (error) {
      console.error('Failed to download export:', error);
      setLoading(false);
      setErrorOpen(true);
    }
  };

  return (
    <>
      <MenuItem onClick={() => setConfirmOpen(true)} disabled={loading}>
        <ListItemIcon sx={{ minWidth: 28 }}>
          {loading ? <CircularProgress size={16} /> : <FileDownloadOutlinedIcon fontSize="small" />}
        </ListItemIcon>
        <ListItemText primary={label} />
      </MenuItem>
      <ExportDownloadConfirmDialog
        isOpen={confirmOpen}
        handleClose={() => setConfirmOpen(false)}
        handleDownload={handleDownload}
      />
      <Snackbar
        open={errorOpen}
        autoHideDuration={6000}
        onClose={() => setErrorOpen(false)}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Alert onClose={() => setErrorOpen(false)} severity="error" variant="filled">
          Download failed. Please try again.
        </Alert>
      </Snackbar>
    </>
  );
}
